module.exports = __webpack_public_path__ + "a82004f62e045a3cc66b614376e730ce.png";